import React, { useEffect, useState, useCallback } from "react";
import { countryTr } from "../util/countryTr";
import modApi from "../util/moderationApi";
import { baseURL } from "../util/config";

const PageHead = ({ title, sub, right }) => (
  <div className="badu-page-head">
    <div>
      <h4>{title}</h4>
      {sub && <div className="sub">{sub}</div>}
    </div>
    {right}
  </div>
);

const LiveStreams = () => {
  const [streams, setStreams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [auto, setAuto] = useState(true);
  const [lastSync, setLastSync] = useState(null);

  const load = useCallback(async () => {
    const res = await modApi.liveStreams();
    if (res?.status) setStreams(res.streams || []);
    setLastSync(new Date());
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  // Canlı denetim ekranı: moderatörün elindeki liste taze olmalı.
  useEffect(() => {
    if (!auto) return;
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [auto, load]);

  const endStream = async (s) => {
    const reason = window.prompt(
      `"${s.name || "Host"}" yayınını kesmek üzeresin.\n\nSebep (işlem günlüğüne yazılacak):`,
      ""
    );
    if (reason === null) return;

    const res = await modApi.endStream(s._id, reason);
    if (res?.status) {
      setStreams((prev) => prev.filter((x) => x._id !== s._id));
    } else {
      window.alert(res?.message || "Yayın kesilemedi.");
    }
  };

  // Agora mosValue 0-500 -> 1-5; 3 dk'dan eski olcum gosterilmez
  const quality = (s) => {
    const q = s.vq;
    if (!q || !q.mos || Date.now() - new Date(q.at).getTime() > 180000) return <span style={{ opacity: 0.5 }}>—</span>;
    const p = q.mos / 100;
    const color = p >= 4 ? "#22c55e" : p >= 3 ? "#eab308" : "#ef4444";
    return (
      <span title={`Donma %${Math.round(q.frz || 0)} · ${q.h || "?"}p · ${q.n || 0} ölçüm`}>
        <b style={{ color }}>{p.toFixed(1)}</b>
        <span style={{ opacity: 0.6, fontSize: 12 }}> {q.h ? `${q.h}p` : ""}{q.frz >= 1 ? ` · donma %${Math.round(q.frz)}` : ""}</span>
      </span>
    );
  };

  const since = (d) => {
    const mins = Math.floor((Date.now() - new Date(d).getTime()) / 60000);
    if (mins < 1) return "az önce";
    if (mins < 60) return `${mins} dk`;
    return `${Math.floor(mins / 60)} sa ${mins % 60} dk`;
  };

  return (
    <>
      <PageHead
        title="Canlı Yayınlar"
        sub="Şu an yayında olan host'lar — uygunsuz içerikte yayını buradan kesebilirsin."
        right={
          <div className="d-flex align-items-center" style={{ gap: 10 }}>
            <label className="mb-0" style={{ fontSize: 12, color: "#6B7280" }}>
              <input
                type="checkbox"
                checked={auto}
                onChange={(e) => setAuto(e.target.checked)}
                style={{ marginRight: 6 }}
              />
              10 sn'de bir yenile
            </label>
            <button type="button" className="btn btn-primary" onClick={load}>
              Yenile
            </button>
          </div>
        }
      />

      <div className="badu-bento" style={{ marginBottom: 12 }}>
        <div className="badu-tile">
          <p className="badu-lbl">Yayında</p>
          <div className="badu-val">{streams.length}</div>
        </div>
        <div className="badu-tile">
          <p className="badu-lbl">Görüşmede</p>
          <div className="badu-val">{streams.filter((s) => s.isInCall).length}</div>
        </div>
        <div className="badu-tile">
          <p className="badu-lbl">Toplam izleyici</p>
          <div className="badu-val">
            {streams.reduce((t, s) => t + (s.view || 0), 0)}
          </div>
        </div>
        <div className="badu-tile">
          <p className="badu-lbl">Son güncelleme</p>
          <div className="badu-val" style={{ fontSize: 15, marginTop: 9 }}>
            {lastSync ? lastSync.toLocaleTimeString("tr-TR") : "—"}
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Host</th>
                  <th>Ülke</th>
                  <th>Süre</th>
                  <th>İzleyici</th>
                  <th>Coin</th>
                  <th title="İzleyicilerin aldığı görüntü kalitesi (Agora, 1-5). Son 3 dk.">Kalite</th>
                  <th>Durum</th>
                  <th>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="8">
                      <div className="badu-empty">Yükleniyor…</div>
                    </td>
                  </tr>
                ) : streams.length === 0 ? (
                  <tr>
                    <td colSpan="8">
                      <div className="badu-empty">Şu an yayında kimse yok.</div>
                    </td>
                  </tr>
                ) : (
                  streams.map((s) => (
                    <tr key={s._id}>
                      <td>
                        <div className="d-flex align-items-center" style={{ gap: 9 }}>
                          {s.image && (
                            <img
                              className="table_image"
                              src={s.image?.startsWith("http") ? s.image : `${baseURL}${s.image}`}
                              alt=""
                            />
                          )}
                          <b>{s.name || "—"}</b>
                        </div>
                      </td>
                      <td>{countryTr(s.country)}</td>
                      <td>{since(s.createdAt)}</td>
                      <td>{s.view || 0}</td>
                      <td>{s.coin || 0}</td>
                      <td>{quality(s)}</td>
                      <td>
                        <span className={`badu-chip ${s.isInCall ? "live" : "ok"}`}>
                          {s.isInCall ? "Görüşmede" : "Yayında"}
                        </span>
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-danger badu-destructive"
                          onClick={() => endStream(s)}
                        >
                          Yayını kes
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default LiveStreams;
